import { APIClient } from "./apiCore";
import * as url from "./urls";
import { Utils } from "../helpers/utils";
import { MemberRole, TaskStatus, WpEmpFilterType } from "../../src/redux/workplace/wpTypes"
import { WpModes } from "../constants";
import { SavePostInfoParm } from "types";

const api = new APIClient();

export const loadPostTitleApi = (wpMode: WpModes, keyword: string, tagSet: string[], memberRole: MemberRole, tagIds: number[] | null, filterUnRead: boolean, filterNotClose: boolean, empFilterType: WpEmpFilterType/*includeFilterEmpRelated: boolean | null*/
  , includePostIds: string[] | null, tagCatMatchedAll?: string[] | null, callFrom?: string, taskStatus?: TaskStatus[] | null
  , filterFromDash?: boolean | null, taskResponder?: number | null, taskAssigner?: number | null, taskRequester?: number | null
  , taskRange1?: Date | null, taskRange2?: Date | null
) => {

  const arg = {
    wpMode, keyword, tagSet, memberRole, tagIds: tagIds, filterUnRead: filterUnRead, filterNotClose: filterNotClose, empFilterType/*includeFilterEmpRelated*/, includePostIds, tagCatMatchedAll, taskStatus
    , filterFromDash, taskResponder, taskAssigner, taskRequester
    , taskRange1, taskRange2
  };
  // console.log(`loadPostTitleApi(${callFrom}):`, arg);
  return api.fnPostForm(url.WP_LOAD_POST_TITLE, arg);
}

export const loadPostConverApi = (mode: WpModes, postId: string) => {
  return api.fnPostForm(url.WP_LOAD_POST_CONVER2, { mode, postId });
}

export const loadPostInfoApi = (postId: string) => {
  // return api.fnPostForm(url.WP_LOAD_POST_INFO2, { wpMode, postId });
  return api.fnPostForm(url.WP_LOAD_POST_INFO3, { postId });
}

export const updateReadApi = (postIdParent: string) => {
  return api.fnPostForm(url.WP_UPDATE_READ, { postIdParent });
}

export const getRoleUnreadCountApi = (sendNotification: boolean) => {
  return api.fnPost(url.WP_GET_ROLE_UNREAD_COUNT, { sendNotification });
}

export const loadDllEmployeeApi = () => {
  return api.fnPost(url.GET_DLL_VALUE_USER, {});
}

export const loadTaskDashApi = (statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null) => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASH, { statusRange1, statusRange2, filterTagId });
}

export const loadTaskDashTagsApi = () => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASH_TAGS, {});
}

export const loadTaskDashStatusrangeApi = (statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null) => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASH_STATUSRANGE, { statusRange1, statusRange2, filterTagId });
}

export const savePostInfo = async (parm: SavePostInfoParm) => {
  return api.fnPostBody(url.WP_SAVE_POST_INFO, parm);
}

export const loadSubTaskApi = async (parentTaskId: string) => {
  return api.fnPostForm(url.WP_LOAD_SUB_TASK, { parentTaskId });
}

export const tagMasterCatLoadApi = async () => {
  return api.fnPostForm(url.WP_TAG_MASTER_CAT_LOAD, {});
}
